import { IBitComment } from 'types/src/types';
import { AuthorInfo } from './AuthorInfo';
import { Button } from '@workspace/ui/components/button';
import { Icon } from '@/src/components/ui';
import { useBoolean } from '@/src/hooks/use-boolean';
import { CreateComment } from './CreateComment';
import { cn } from '@workspace/ui/lib/utils';
import { Report } from '@/src/sections/bits/components/Report';

type Props = {
  comment: IBitComment;
  level?: number;
  onCommentPosted?: () => void;
};

export const CommentItem = ({ comment, level = 0, onCommentPosted }: Props) => {
  const isReply = useBoolean(false);
  const { author } = comment;
  const authorName = level !== 0 ? `${author.name} to` : author.name;
  return (
    <div className="md:mt-4 mt-2">
      <div className="flex items-center justify-between">
        <AuthorInfo
          authorName={author.name}
          authorImage={author.avatarUrl}
          authorUniqueLink={author.uniqueLink}
          createdAt={comment.createdAt}
          authorId={author.id}
          isComment={true}
          isPartner={author.isPartner}
        />
        <div className="text-sm md:text-base">
          {!comment.replyTo && (
            <Button
              size="icon"
              variant="ghost"
              className="px-2 py-1"
              onClick={() => isReply.onToggle()}
            >
              <Icon
                name="reply"
                width={16}
                height={16}
                className="text-black/40"
              />
            </Button>
          )}
          <Report bitId={comment.bitId} socialCommentId={comment.id} type="comment" />
        </div>
      </div>
      <div
        className={cn('font-light text-base mt-4 whitespace-pre-line', {
          'text-black/60': level === 1,
        })}
      >
        {comment.content}
      </div>
      {isReply.value && (
        <CreateComment
          bitId={comment.bitId}
          replyToComment={comment}
          placeholder={`Reply to ${author.name}`}
          onCommentPosted={onCommentPosted}
        />
      )}
    </div>
  );
};
